<script>
	import Header from "../components/Header.svelte";
	import { plan_type_store } from "../stores.js";


	let plan_type = '';
	plan_type_store.subscribe(value => {
		plan_type = value;
	});
</script>


<Header />
<div class='message_container'>
	<h2>{plan_type === 'basic' ? 'Thank you for contacting us. An email was sent to you.' : 'Thank you for booking the service with us. An email confirmation was sent to you.'}</h2>
</div>


<style>
	.message_container {
		width: 80%;
		margin: auto;
	}
</style>